module.exports = __webpack_public_path__ + "img/phifer-logo.e58de5f9.jpg";